export default function getRandomElements(array, count) {
  const copy = [...array];
  // Shuffle the copied array
  const shuffled = copy.sort(() => 0.5 - Math.random());
  // Return the first `count` elements
  return shuffled.slice(0, count);
}
